import { ArticleContent } from "./ArticleContent";

export function ArticlePreview({ markdown }: { markdown: string }) {
  return (
    <div className="paywall-fade">
      <ArticleContent markdown={markdown} />
    </div>
  );
}
